import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import Progress from "../Component/Progress";

const Container = styled.div`
  width: 100%;
  height: 70px;
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
  overflow-x: hidden;
  @media (max-height: 400px) {
    display: none;
  }
`;

const Box = styled.div`
  width: 60%;
  /* max-width: 400px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Author = styled.div``;

const AuthorLink = styled.a`
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;

const Last = styled.div`
  font-size: 24px;
`;

export default withRouter(({ location: { pathname } }) => (
  <Container>
    <Box>
      {pathname === "/" ? (
        <Author>
          <AuthorLink href="https://junwoolee.me" target="_blank">
            ©junwoo
          </AuthorLink>
        </Author>
      ) : pathname === "/finish" ? (
        <Author>
          <AuthorLink href="https://junwoolee.me" target="_blank">
            ©junwoo
          </AuthorLink>
        </Author>
      ) : (
        <Progress stage={pathname}></Progress>
      )}
    </Box>
  </Container>
));
